module.exports = __webpack_public_path__ + "static/media/export-icon.b5186419.svg";